import React, { useState } from "react";
import { trackEvent } from "../utils/analytics";

const Hero = () => {
  const [videoLoaded, setVideoLoaded] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleContactClick = () => {
    trackEvent("kontakt_sekcja_glowna", {
      category: "Sekcja główna",
      label: "Przycisk kontaktu",
      section: "hero",
    });
    scrollToSection("contact");
  };

  const handleLearnMoreClick = () => {
    trackEvent("dowiedz_sie_wiecej_glowna", {
      category: "Sekcja główna",
      label: "Przycisk dowiedz się więcej",
      section: "hero",
    });
    scrollToSection("about");
  };

  const handleScrollIndicatorClick = () => {
    trackEvent("strzalka_przewijania", {
      category: "Sekcja główna",
      label: "Strzałka przewijania w dół",
      section: "hero",
    });
    scrollToSection("specialization");
  };

  return (
    <section
      id="hero"
      className="relative h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Video */}
      <div className="absolute inset-0 z-0">
        <video
          className="w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          onLoadedData={(e) => {
            setVideoLoaded(true);
            e.target.playbackRate = 0.66;
          }}
          poster="/videos/placeholder.jpeg"
        >
          <source src="/videos/hero-video.webm" type="video/webm" />
        </video>

        {/* Fallback image for when video doesn't load */}
        {!videoLoaded && (
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url('/videos/placeholder.jpeg')`,
            }}
          />
        )}

        {/* Dark overlay */}
        <div className="absolute inset-0 video-overlay" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-white container-custom">
        <div className="max-w-7xl">
          <h1 className="hero-title font-heading mb-6 animate-fade-in">
            LUMAT – Twój partner w automatyce przemysłowej
          </h1>

          <p className="hero-subtitle md:text-xl lg:text-lg mb-12 max-w-3xl opacity-90 animate-slide-up">
            Od 2008 roku wspieramy przemysł w całej Polsce, dostarczając
            niezawodne rozwiązania z zakresu <strong>automatyki</strong>,{" "}
            <strong>pneumatyki</strong>, <strong>hydrauliki</strong> i{" "}
            <strong>elektrotechniki</strong>. Oferujemy szeroki wybór
            komponentów, doradztwo techniczne oraz serwis oparty na
            doświadczeniu i elastycznym podejściu do potrzeb klienta.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 animate-slide-up">
            <button
              onClick={handleContactClick}
              className="btn-primary text-xl px-6 my-1"
            >
              Skontaktuj się z nami
            </button>

            <button
              onClick={handleLearnMoreClick}
              className="btn-secondary text-xl px-6 my-1"
            >
              Dowiedz się więcej
            </button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <button
          onClick={handleScrollIndicatorClick}
          className="text-white opacity-70 hover:opacity-100 transition-opacity animate-bounce"
          aria-label="Scroll to next section"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        </button>
      </div>
    </section>
  );
};

export default Hero;
